// Function to check the existence of both OTT and URL fields
export const checkOttAndUrl = (inputData, data) =>
  data.every((element, index) => {
    const ottLabelPresent = inputData.ott[index].label
    const urlNotEmpty = element.link.length > 0

    // Both OTT label and URL are present or absent
    return (ottLabelPresent && urlNotEmpty) || (!ottLabelPresent && !urlNotEmpty)
  })

// Function to check if OTT fields exist based on certain conditions
export const checkOttFieldsDateExistsorNot = (checkOttFieldsExists, ottDates) => {
  //   console.log(checkOttFieldsExists, 'checkOttFieldsExists')
  if (checkOttFieldsExists) {
    if (ottDates.length > 0) {
      return true
    }

    return false
    // const releaseDate = new Date(inputData.releaseDate).getFullYear()
    // return releaseDate <= 2015 || inputData.ottDateUi
  }

  return true
}

export const checkReviewValidationEn = input =>
  Boolean(
    (input.articleReviewTitle_En &&
      input.articleReviewURL_En &&
      input.articleReviewDescription_En &&
      input.articleReviewRating) ||
      (!input.articleReviewTitle_En &&
        !input.articleReviewURL_En &&
        !input.articleReviewDescription_En),
  )
export const checkReviewValidationTe = input =>
  Boolean(
    (input.articleReviewTitle_Te &&
      input.articleReviewURL_Te &&
      input.articleReviewDescription_Te &&
      input.articleReviewRating) ||
      (!input.articleReviewTitle_Te &&
        !input.articleReviewURL_Te &&
        !input.articleReviewDescription_Te),
  )

export const checkArticleRating = input => {
  if (
    input.articleReviewTitle_Te &&
    input.articleReviewURL_Te &&
    input.articleReviewDescription_Te
  ) {
    if (input.articleReviewRating) {
      return true
    }

    return false
  }

  if (
    input.articleReviewTitle_En &&
    input.articleReviewURL_En &&
    input.articleReviewDescription_En
  ) {
    if (input.articleReviewRating) {
      return true
    }

    return false
  }

  if (input.articleReviewRating) {
    return false
  }

  return true
}

export const ArticleValidation = (reviewValidationEn, reviewValidationTe, articleReviewRatingCheck) => reviewValidationEn && reviewValidationTe && articleReviewRatingCheck
export const releaseDateValidation = (status, releaseDate, inputData) => {
  if (status.includes('MovieReleaseDateRevealed') || status.includes('MovieReleased')) {
    return releaseDate !== ''
  }

  if (status.includes('DirectlyAvailableOnOTT')) {
    return checkOTTStatus(inputData)
  }

  return true
}

export const checkValidation = inputData =>
  inputData.language.length > 0 &&
  inputData.movieName !== '' &&
  inputData.movieNamete !== '' &&
  inputData.poster.length > 0 &&
  inputData.Bio.length > 3 &&
  inputData.biote.length > 3 &&
  inputData.genRe.length >= 1 &&
  inputData.Moviecast.length >= 1 &&
  inputData.Moviedirector.length >= 1 &&
  inputData.MovieProducer.length >= 1 &&
  inputData.restrit !== ''

export function checkOTTStatus(inputData) {
  return (
    inputData.OTTStatus === 'OTTProviderDateAndLinkAvailable' ||
    inputData.OTTStatus === 'OTTProviderRevealedAndLinkAvailableAndDateNotKnown' ||
    inputData.OTTStatus === 'OTTProviderAndDateKnownAndLinkNotAvailable' ||
    inputData.OTTStatus === 'OTTProviderRevealedAndDateAnnounced' ||
    inputData.OTTStatus === 'OTTProviderRevealedAndDateTBA'
  )
}
